export enum Views {
    DASHBOARD = "/dashboard",
    ASSET_TABLE = "/assets",
    TICKET_TABLE = "/tickets",
    USER_TABLE = "/users",
    REPORTING = "/reporting",
    SIGN_IN = "/sign-in",
    PROFILE = "/my-profile",
    HOME = "/",
    INSIGHTS = "/insights",
    QUAGGA = "/quagga",
    FALLBACK = "/fallback",
    CHEAT_SHEET = "/cheat-sheet",
    CAPABILITIES = "/capabilities",
    RESET_PASSWORD = "/reset-password",
    GOOGLE_AUTH_CALLBACK = "/auth/google/callback",
    MICROSOFT_AUTH_CALLBACK = "/auth/microsoft/callback",
}

export const TICKET_KEY_FOR_ASSETS = "ticket_to_asset_to";

export type OptionalClassName<T> = T & {
    className?: string;
};
